import React from 'react';

const interestTags = [
  'Film curation', 'Human rights', 'Gender & labour',
  'South Asian diaspora', 'Digital media', 'Strategic communications', 'Ethnographic research',
];

const About = () => (
  <section id="about" className="bg-bg-primary" style={{ borderBottom: '0.5px solid #e0ddd8' }}>
    <div className="grid md:grid-cols-2" style={{ borderBottom: 'none' }}>
      {/* Left — About */}
      <div className="p-10" style={{ borderRight: '0.5px solid #e0ddd8' }}>
        <span className="section-label">About</span>
        <p className="text-muted mb-5" style={{ fontSize: '14px', lineHeight: 1.8 }}>
          Based between <strong className="text-ink font-medium">Karachi, New York, and Toronto</strong>, I am a journalist, filmmaker, and media curator with a decade of practice spanning newsrooms, non-profits, film festivals, and academic publishing.
        </p>
        <p className="text-muted" style={{ fontSize: '14px', lineHeight: 1.8 }}>
          My work asks how <strong className="text-ink font-medium">documentary, archive, and community programming</strong> can contest dominant narratives around gender, indigeneity, and migration. I hold an MA in Global Journalism with a minor in Cinema Studies from <strong className="text-ink font-medium">NYU</strong> (2022).
        </p>
        <ul className="flex flex-wrap gap-2 mt-5">
          {interestTags.map((tag) => (
            <li key={tag} className="interest-tag">{tag}</li>
          ))}
        </ul>
      </div>

      {/* Right — Currently */}
      <div className="p-10">
        <span className="section-label">Currently</span>
        <p className="text-muted mb-5" style={{ fontSize: '14px', lineHeight: 1.8 }}>
          Co-founding <strong className="text-ink font-medium">Echoes of the Indus</strong>, a grassroots film and culture collective in Toronto building thematic programs on climate, identity, and solidarity within the South Asian diaspora.
        </p>
        <p className="text-muted" style={{ fontSize: '14px', lineHeight: 1.8 }}>
          Open to <strong className="text-ink font-medium">lecturer positions</strong> in media studies, journalism, and cultural theory, and <strong className="text-ink font-medium">curatorial roles</strong> in film and contemporary arts institutions.
        </p>
        <div className="mt-6 p-4 bg-bg-secondary" style={{ borderRadius: '2px' }}>
          <p className="text-muted" style={{ fontSize: '12px', lineHeight: 1.6 }}>
            Published in{' '}
            <span className="highlight-chip">MIT Press</span>{' '}
            <span className="highlight-chip">Zubaan</span>{' '}
            <span className="highlight-chip">Herald Magazine</span>{' '}
            <span className="highlight-chip">Dawn</span>
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default About;
